exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-veteran-js": () => import("./../../../src/templates/veteran.js" /* webpackChunkName: "component---src-templates-veteran-js" */)
}

